import { ProjectStatus } from '@belimo-retrofit-portal/logic';

export const STATUS_OPTIONS = [ProjectStatus.HOLD, ProjectStatus.ACTIVE, ProjectStatus.WON, ProjectStatus.CANCELLED];
